import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { onBeforeUnmount, onMounted, useTemplateRef, watch } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FormLocker',
    props: {
        message: { type: String, required: true },
        lock: Boolean,
    },
    setup: function (__props) {
        var props = __props;
        var element = useTemplateRef('element');
        var watcher = watch([function () { return [props.lock, props.message]; }], updateLock);
        onMounted(updateLock);
        onBeforeUnmount(function () { return watcher.stop(); });
        function updateLock() {
            var _a;
            (_a = element.value) === null || _a === void 0 ? void 0 : _a.setCustomValidity(props.lock ? props.message : '');
        }
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("input", {
                type: "text",
                ref_key: "element",
                ref: element,
                tabindex: "-1"
            }, null, 512 /* NEED_PATCH */));
        };
    }
});
